import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import { useParams } from 'react-router-dom';
import { Loading } from 'src/components/Loading';
import { TrackingColiPublicAuthFom } from '../TrackingColisPublic/components/TrackingColiPublicAuthFom';
import { useTrackingColiPublicForm } from '../TrackingColisPublic/components/TrackingColiPublicAuthFom/useTrackingColiPublicForm';
import { DeliveryPublicColiInfoContent } from './components/DeliveryPublicColiInfoContent';
import { useDeliveryPublicColiInfo } from './hooks';

type Props = {
  testID?: string;
};

export const DeliveryPublicColiInfo: React.FC<Props> = ({ testID = 'DeliveryPublicColiInfo' }) => {
  const params = useParams<{ tracking: string; code: string }>();
  const { isLoading, error, fetchData, data } = useDeliveryPublicColiInfo({ includeTimeSlots: false });
  const { control, errors, handleSubmit, code } = useTrackingColiPublicForm(params);

  useEffect(() => {
    if (params) {
      fetchData({ tracking: params.tracking, code: params.code });
    }
  }, [params, fetchData]);

  useEffect(() => {
    if (data && params) {
      ReactGA.event({
        category: 'Receiver',
        action: 'InfoColis',
        label: `${params.tracking}/${params.code}`,
      });
    }
  }, [data, params]);

  if (isLoading) {
    return <Loading />;
  }

  if (!data) {
    return (
      <TrackingColiPublicAuthFom
        onSubmit={fetchData}
        error={error}
        errors={errors}
        handleSubmit={handleSubmit}
        control={control}
      />
    );
  }
  return <DeliveryPublicColiInfoContent data={data} code={code} />;
};
